import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/station-page_car-wash.png")